/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';

/**
 * 
 * @export
 * @interface GetChallengeChallengeIdV2200Response
 */
export interface GetChallengeChallengeIdV2200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetChallengeChallengeIdV2200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetChallengeChallengeIdV2200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {string}
     * @memberof GetChallengeChallengeIdV2200Response
     */
    result?: string;
}

/**
 * Check if a given object implements the GetChallengeChallengeIdV2200Response interface.
 */
export function instanceOfGetChallengeChallengeIdV2200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetChallengeChallengeIdV2200ResponseFromJSON(json: any): GetChallengeChallengeIdV2200Response {
    return GetChallengeChallengeIdV2200ResponseFromJSONTyped(json, false);
}

export function GetChallengeChallengeIdV2200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetChallengeChallengeIdV2200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function GetChallengeChallengeIdV2200ResponseToJSON(value?: GetChallengeChallengeIdV2200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': value.result,
    };
}

